import { createFileRoute } from '@tanstack/react-router';
import { RequestPage } from '@/features/signatures';

/** One signature request: facts, signers, signing, proof. The notifications link here. */
export const Route = createFileRoute('/_auth/o/$orgId/signatures/$requestId')({
  component: RequestRoute,
});

function RequestRoute() {
  const { orgId, requestId } = Route.useParams();
  return <RequestPage orgId={orgId} requestId={requestId} />;
}
